export const findElementFromAccessor = (order, accessor) => {
  let value = order;
  accessor.split('.').forEach((elem) => {
    value = value?.[elem];
  });
  return value;
};
